import './App.css';
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
  <Weather />
       <footer>
      <a href="https://www.shecodes.io/" 
      target="_blank" 
      rel="noreferrer" 
      title="SheCodes WeatherApp React Project">
      SheCodes</a> 
      {" "} React Project coded in April 2026 by {" "}
      <a href="https://www.shecodes.io/graduates/15505-emily-berner" 
      target="_blank" 
      rel="noreferrer" 
      title="Emily's SheCodes profile">
        Emily Berner</a>
      , open-sourced on {" "}
      <a href="https://github.com/Emmily0/react-weather-app-project-shecodes-eb-042026" 
      target="_blank" 
      rel="noreferrer" 
      title="Emily's WeatherApp React Project on GitHub">
      GitHub</a>{" "}  
      and hosted on {" "}
      <a href="https://react-weatherapp-p-shecodes-eb-042026.netlify.app/" 
      target="_blank" 
      rel="noreferrer" 
      title="Emily's WeatherApp React Project on Netlify">
      Netlify</a>.{" "}
      <br />
      Outfit imagery generated with Canva AI.
  </footer>
    </div>
    </div>
  );
};